export default "__VITE_ASSET__iAvT6B4H__"